var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiffyLube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237.3 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.59,44.19c2.07-.15,3.62-.63,4.54-1.57,1.07-1.1,1.52-3,1.52-7.81V17.19H78v19.5c0,4.88-1.08,8.08-3.22,10.18s-5.69,3-9.44,3ZM74.3,14.3a3.76,3.76,0,0,1-4-3.45v-.32c0-2.08,1.56-3.73,4.12-3.73A3.76,3.76,0,1,1,75,14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.58,14.3a3.76,3.76,0,0,1-4-3.5h0v-.26c0-2.08,1.55-3.73,4.1-3.73a3.77,3.77,0,1,1,.78,7.5,3.39,3.39,0,0,1-.78,0m-3.75,2.89H91.3V39.76H83.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.37,39.76V22.65h-3V17.19h3v-.84c0-2.76.93-6,3-7.86a9.74,9.74,0,0,1,6.53-2.3,13.65,13.65,0,0,1,3.76.47l-.16,5.6a8.85,8.85,0,0,0-2.4-.33c-2.41,0-3.46,1.83-3.46,4.08v1.18h4.73v5.47h-4.65v17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.13,39.76V22.65h-3V17.19h3v-.84c0-2.76.93-6,3-7.86a9.77,9.77,0,0,1,6.54-2.3,13.92,13.92,0,0,1,3.75.47l-.15,5.6a8.85,8.85,0,0,0-2.4-.33c-2.42,0-3.45,1.83-3.45,4.08v1.18h4.71v5.47h-4.64v17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.77,17.19l3.75,10.87c.43,1.33.95,3.17,1.29,4.34H136c.36-1.24.77-3,1.16-4.37l3.09-10.84h8l-5.44,14c-4,10.54-6.34,13.86-8.92,15.9A13.16,13.16,0,0,1,126.56,50l-1.39-6.14a10.33,10.33,0,0,0,3.07-1A8.18,8.18,0,0,0,131.47,40a2,2,0,0,0,.42-1,2.82,2.82,0,0,0-.36-1.27l-9-20.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 154.39,
    y: 7.01,
    width: 4.03,
    height: 32.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.74,33.65c0,2.34.08,4.34.19,6.11H178.3l-.22-3.65H178a8.37,8.37,0,0,1-7.39,4.15c-3.48,0-7.68-2-7.68-9.78v-13h4V29.77c0,4.26,1.32,7.15,5,7.15a5.92,5.92,0,0,0,5.44-3.73,6.41,6.41,0,0,0,.36-2.08V17.45h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.63,7h4V21h.1a8.23,8.23,0,0,1,7.6-4.09c5.53,0,9.44,4.59,9.42,11.35,0,8-5.08,12-10,12a8.06,8.06,0,0,1-7.45-4.18h-.11l-.2,3.67h-3.51c.1-1.53.18-3.77.18-5.75Zm4,23.8a6.62,6.62,0,0,0,.16,1.47A6.25,6.25,0,0,0,196.88,37c4.28,0,6.78-3.45,6.78-8.57,0-4.49-2.32-8.33-6.66-8.33a6.47,6.47,0,0,0-6.13,5,7,7,0,0,0-.24,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.14,29.33c.08,5.49,3.57,7.75,7.63,7.75A15,15,0,0,0,228,35.94l.72,2.87a17.94,17.94,0,0,1-7.44,1.43c-6.87,0-11-4.57-11-11.27s4-12,10.49-12c7.28,0,9.18,6.37,9.18,10.48a10.06,10.06,0,0,1-.13,1.9ZM226,26.42c0-2.56-1.05-6.57-5.6-6.57-4.15,0-5.91,3.75-6.23,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.93,9.61,26,35.13a4.09,4.09,0,0,1-4.28,3.49,4.23,4.23,0,0,1-4.14-2.94H8.49C9.06,42,14.77,46.89,21.75,46.89S34,42.63,35,36L40,9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,33.67a4.22,4.22,0,0,1,4.15-3h3l1.59-8.27H21.75c-7,0-12.7,4.93-13.26,11.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.04 30.66 42.3 30.66 41.36 35.22 52.33 26.55 44.69 18.33 43.84 22.42 39.61 22.42 38.04 30.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.92,28A25.92,25.92,0,1,1,28,2.08h0A25.91,25.91,0,0,1,53.92,28v0M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.3,20a2,2,0,1,1-2-2A2,2,0,0,1,237.3,20Zm-3.53,0a1.53,1.53,0,0,0,1.49,1.57h0a1.5,1.5,0,0,0,1.5-1.5V20a1.52,1.52,0,0,0-3-.53v0a1.35,1.35,0,0,0,0,.49ZM235,21h-.46V19a4.87,4.87,0,0,1,.76-.06,1.12,1.12,0,0,1,.67.15.5.5,0,0,1,.2.42.51.51,0,0,1-.4.47h0c.19.06.28.22.34.48a1.34,1.34,0,0,0,.15.48h-.48a1.6,1.6,0,0,1-.16-.48c0-.2-.15-.3-.41-.3H235Zm0-1.1h.22c.25,0,.45-.08.45-.29s-.13-.3-.42-.3H235Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiffyLube);
export default __webpack_public_path__ + "static/media/jiffy-lube.54acf600227798ccfe7a9e07c23b74c3.svg";
export { ForwardRef as ReactComponent };